import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  ItcdAnalyticsSelectedItemCommand,
  RefresheSelectedItemCommand
} from '@shared/commands/dashboard.command';
import {CommandService} from '@core/services/command.service';
import {getCurrentProject, ProjectState} from '../../projects/store/reducers/projects.reducer';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {Guid} from 'guid-typescript';
import {DashboardService} from '@core/services/dashboard.service';

@Component({
    standalone: false,
    selector: 'particle-itcd-analytics',
  templateUrl: './itcd-analytics.component.html',
  styleUrls: ['./itcd-analytics.component.scss']
})
export class ItcdAnalyticsComponent implements OnInit, OnDestroy {
  dataLoaded: boolean;
  failureResponse = false;
  refreashQueryKey = 'refreshVisualizer';
  refreshReportType = 'DAC6Report';
  invokeReloadReport: any;
  reportDetails: any;
  private unsubscribe$ = new Subject<void>();
  private currentProject: string;
  scenarios: any;
  selectedScenario: any;
  dummyScene = [
    {
      scenarioId: '11',
      scenarioName: 'S-1'
    },
    {
      scenarioId: '12',
      scenarioName: 'S-2'
    },
    {
      scenarioId: '13',
      scenarioName: 'S-3'
    }
  ];
  constructor(private commandService: CommandService,
              private dashboardService: DashboardService,
              private projectStore: Store<ProjectState>) {
  }

  ngOnInit() {
    this.invokeReloadReport = Guid.create().toString();
    const project$ = this.projectStore.pipe(select(getCurrentProject), takeUntil(this.unsubscribe$)); //
    project$.subscribe((project: any) => {
      if (project) {
        this.currentProject = project.ProjectId;
        this.dashboardService.getItcdScenario(project.ProjectId).subscribe((scenarios: any[]) => {
          if (scenarios && scenarios.length > 0) {
            this.scenarios = scenarios;
            this.selectedScenario = this.scenarios[0].scenarioId;
            const command = new ItcdAnalyticsSelectedItemCommand(this.currentProject, this.selectedScenario);
            this.getReportData(command);
          }
        });
      }
    });
  }

  private getReportData(command: any) {
    this.commandService.executeCommand(command).subscribe((response: any) => {
      if (response) {
        this.failureResponse = false;
        this.dataLoaded = true;
        this.reportDetails = {
          reportId: response.Payload.ReportId,
          groupId: response.Payload.GroupId,
          embedToken: response.Payload.EmbedToken
        };
      }
    }, error => {
      this.failureResponse = true;
      this.dataLoaded = false;
    });
  }
  onResetReport(event) {
    this.invokeReloadReport = Guid.create().toString();
    const command = new ItcdAnalyticsSelectedItemCommand(this.currentProject, this.selectedScenario, true);
    command.payload = {
      home : false
    };
    this.getReportData(command);
  }
  onRefreshReport(event) {
    this.invokeReloadReport = Guid.create().toString();
    const command = new RefresheSelectedItemCommand('', {home : false}, '');
    this.getReportData(command);
  }
  onSelectScenarion(event) {
    this.invokeReloadReport = Guid.create().toString();
    this.selectedScenario = event.value;
    const command = new ItcdAnalyticsSelectedItemCommand(this.currentProject, this.selectedScenario);
    this.getReportData(command);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
